export function variationGalleryImage(selector = '.product-swiper') {
  const $form = jQuery('form.variations_form');
  if (!$form.length) return;

  const $container = jQuery(selector);
  if (! $container.length) return;

  let thumbsMap;
  let def_first_img_url;

  let $slides = $container.find('.swiper-slide');
  let $pagination_bullets = $container.find('.swiper-pagination__bullet');
  jQuery(document).on('swiperReady', (event) => {
    $pagination_bullets = $container.find('.swiper-pagination__bullet');
    if (! $slides.length || ! $pagination_bullets.length) return;
    init();
  });

  const init = () => {
    try {
      thumbsMap = JSON.parse($container.attr('data-variations-thumbs'));
    } catch (e) {
      console.error('Invalid datasheets JSON in', selector);
      return;
    }

    def_first_img_url = $slides.eq(0).find('a').attr('href');

    $form.on('found_variation', function (event, variation) {
      updateFirstGalleryItem(variation && variation.variation_id);
    });

    $form.on('reset_data', function () {
      resetFirstGalleryItem();
    });

    // Trigger WooCommerce to re-check variations and fire found_variation if possible
    $form.trigger('check_variations');
  }

  const replaceFirstGalleryItem = (url) => {
    $slides.eq(0).find('a').attr('href', url);
    $slides.eq(0).find('img').attr('src', url);
    $pagination_bullets.eq(0).find('img').attr('src', url);
  };
  const resetFirstGalleryItem = () => {
    $slides.eq(0).find('a').attr('href', def_first_img_url);
    $slides.eq(0).find('img').attr('src', def_first_img_url);
    $pagination_bullets.eq(0).find('img').attr('src', def_first_img_url);
  };
  const updateFirstGalleryItem = (variationId) => {
    if (variationId && thumbsMap[variationId]) {
      replaceFirstGalleryItem(thumbsMap[variationId]);
    } else {
      resetFirstGalleryItem();
    }
  };
}
